import { IParametro } from "../redux/types/parametroActionTypes";
import { enums } from "../enums/enums";
import { IRecoleccion } from "../redux/types/recoleccionActionTypes";
import { IServicioAdicional, ServicioAdicional } from "../entities/catalogos/ServicioAdicional";
import { ISolicitud, Solicitud } from "../entities/solicitudes/Solicitud";
import { Mercancia } from "../entities/solicitudes/Mercancia";
import { initialMercancia } from "../redux/reducers/mercanciaReducer";
import { AreaServicio } from "../entities/catalogos/AreaServicio";
import { ICliente } from "../entities/catalogos/ICliente";
import { Sucursal } from "../entities/catalogos/Sucursal";
import { Recoleccion } from "../entities/catalogos/Recoleccion";
import { traducirButton, traducirLabel, traducirMessage } from  "./traductor";

export function getValorParametro(parametros: IParametro[], propiedad: string, decimales: number = -1): number {
    const parametro = parametros.find(p => p.id === enums.parametro[propiedad]);
    let valor = Number(parametro?.valor);
    if (decimales >= 0)
        valor = +(valor.toFixed(decimales));

    return valor;
}

export function validarCruceServiciosAdicionales(recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion): string {
    if (!recoleccionDestino.completado) return "";

    const serviciosOrigen = recoleccionOrigen.serviciosAdicionales;
    const serviciosDestino = recoleccionDestino.serviciosAdicionales;
    
    const cruceSeleccionadoOrigen = serviciosOrigen?.some(e => e.nombre.includes("FLETE CRUCE FRONTERIZO") && e.seleccionado);
    const cruceSeleccionadoDestino = serviciosDestino?.some(e => e.nombre.includes("FLETE CRUCE FRONTERIZO") && e.seleccionado);
    const cruceOrigenRequerido = recoleccionOrigen.tieneCruceFronterizo && !cruceSeleccionadoOrigen;
    const cruceDestinoRequerido = !recoleccionOrigen.tieneCruceFronterizo && recoleccionDestino.tieneCruceFronterizo && !cruceSeleccionadoDestino;

    if (cruceOrigenRequerido || cruceDestinoRequerido) {
        let mensaje = traducirMessage(128); // "Favor de seleccionar por lo menos un servicio del tipo Flete Cruce Fronterizo";
        var idioma = localStorage.getItem("idioma");
        if(idioma === 'en-US'){
            return cruceOrigenRequerido ? mensaje + " at the origin" : mensaje;
        }
        else{
            return cruceOrigenRequerido ? mensaje + " en el origen" : mensaje;
        }
    }

    return "";
}

export function validarDestinoInternacional(recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion): string {
    if (!recoleccionDestino.completado) return "";

    if (recoleccionOrigen.esServicioInternacional && recoleccionDestino.esServicioInternacional) {
        let mensaje =  traducirMessage(320); // "El servicio seleccionado está fuera de nuestra área de servicio. Por favor, ajuste el origen o destino";
        return mensaje;
    }

    return "";
}


export function validarCruceSolicitud(recoleccionOrigen: IRecoleccion, recoleccionDestino: IRecoleccion, solicitud: ISolicitud): string {
    if (!recoleccionDestino.completado) return "";
    const cruceFronterizo = solicitud.cruceFronterizo;

    const cruceRequerido = (recoleccionOrigen.esServicioInternacional && !recoleccionDestino.esServicioInternacional)
                            || (!recoleccionOrigen.esServicioInternacional && recoleccionDestino.esServicioInternacional);
    if (cruceRequerido && (cruceFronterizo === undefined || cruceFronterizo === null || (cruceFronterizo && cruceFronterizo.cruce === ""))) {
        let mensaje = traducirMessage(322); // "Favor de seleccionar un cruce fronterizo para este servicio.";
        return mensaje;
    }

    return "";
}

export function setServiciosAdicionales(solicitud: Solicitud) {
    let serviciosAdicionales = [
        {
            id: 0,
            aplicaOrigen: true,
            aplicaDestino: true,
            concepto: { conceptoId: 0, nombreConcepto: '' },
            cantidad: 0,
            cantidadOrigen: 0,
            cantidadDestino: 0,
            costo: 0
        }
    ];

    if (solicitud.serviciosAdicionales?.length) {
        serviciosAdicionales = [];
        const serviciosFiltrados = solicitud.esServicioInternacional
            ? solicitud.serviciosAdicionales.filter(s => !s.esRetornoDocumentos)
            : solicitud.serviciosAdicionales;
        serviciosFiltrados.forEach(s => {
            const cantidadOrigen = s.cantidadOrigen != null ? s.cantidadOrigen : 0;
            const cantidadDestino = s.cantidadDestino != null ? s.cantidadDestino : 0;
            const cantidad = s.esRetornoDocumentos? (s.cantidad ?? 0): cantidadOrigen + cantidadDestino;
            if(!s.costo || !s.costo!=null)
            {
                serviciosAdicionales.push({
                    id: s.id,
                    aplicaOrigen: s.aplicaOrigen,
                    aplicaDestino: s.aplicaDestino,
                    concepto: s.concepto != undefined ? s.concepto : {conceptoId: s.id, nombreConcepto: s.nombre},
                    cantidadOrigen,
                    cantidadDestino,
                    cantidad,
                    costo: s.costo==undefined ? 0: s.costo,
                })
            }
            else
            {
                serviciosAdicionales.push({
                    id: s.id,
                    aplicaOrigen: s.aplicaOrigen,
                    aplicaDestino: s.aplicaDestino,
                    concepto: s.concepto != undefined ? s.concepto : {conceptoId: s.id, nombreConcepto: s.nombre},
                    cantidadOrigen,
                    cantidadDestino,
                    cantidad,
                    costo: !s.esCantidad ? (s.cantidad != null ? s.cantidad : 0) : (s.costo != null ? s.costo : 0),
                })
            }


        });
    }

    if (solicitud.serviciosAdicionalesOrigen?.length) {
        solicitud?.serviciosAdicionalesOrigen.forEach(s => {
            const esCitaRad = s.nombre === 'CARGO POR CITA RAD'
                && solicitud.fechaCitaRad
                && (solicitud.EsRadCitaFueraHorario === undefined || !solicitud.EsRadCitaFueraHorario)
                || (s.nombre === 'FLETE CARGO RAD FUERA DE HORARIO' && solicitud.EsRadCitaFueraHorario === true);
            const noEsOcurre = solicitud.tipoRecoleccionIdOrigen !== undefined && solicitud.tipoRecoleccionIdOrigen !== 3;
            const existe = serviciosAdicionales.some(e => e.id === s.id);
            const servicioEnDestino = solicitud.serviciosAdicionalesDestino?.find(e => e.seleccionado && e.id === s.id);
            const esRetornoDocumentosInternacional = solicitud.esServicioInternacional && s.id === enums.servicioAdicional.retornoDocumentos;

            if (!existe && !esRetornoDocumentosInternacional && (s.seleccionado || (esCitaRad && noEsOcurre))) {
                serviciosAdicionales.push({
                    id: s.id,
                    aplicaOrigen: true,
                    concepto: s.concepto !== undefined ? s.concepto : { conceptoId: s.id, nombreConcepto: s.nombre },
                    aplicaDestino: servicioEnDestino != null,
                    cantidad: s.cantidad ?? 0,
                    cantidadOrigen: s.cantidadOrigen ?? 0,
                    cantidadDestino: servicioEnDestino?.cantidadDestino ?? 0,
                    costo: servicioEnDestino == null ? s.costo ?? 0 : servicioEnDestino.costo ?? 0
                });
            }
        });
    }

    if (solicitud.serviciosAdicionalesDestino?.length) {
        solicitud?.serviciosAdicionalesDestino.forEach(s => {
            const esCitaEad = s.nombre === 'CARGO POR CITA EAD'
                && solicitud.fechaCitaEad
                && (solicitud.EsEadCitaFueraHorario === undefined || !solicitud.EsEadCitaFueraHorario)
                || (s.nombre === 'FLETE CARGO EAD FUERA DE HORARIO' && solicitud.EsEadCitaFueraHorario === true);
            const noEsOcurre = solicitud.tipoRecoleccionIdDestino !== undefined && solicitud.tipoRecoleccionIdDestino !== 3;
            const existe = serviciosAdicionales.some(e => e.id === s.id);
            const esRetornoDocumentosInternacional = solicitud.esServicioInternacional && s.id === enums.servicioAdicional.retornoDocumentos;

            if (!existe && !esRetornoDocumentosInternacional && (s.seleccionado || (esCitaEad && noEsOcurre))) {
                serviciosAdicionales.push({
                    id: s.id,
                    aplicaOrigen: false,
                    concepto: s.concepto !== undefined ? s.concepto : { conceptoId: s.id, nombreConcepto: s.nombre },
                    aplicaDestino: true,
                    cantidad: s.cantidad ?? 0,
                    costo: s.costo ?? 0,
                    cantidadOrigen: 0,
                    cantidadDestino: s.cantidadDestino ?? 0
                });
            }
        });
    }

    return serviciosAdicionales;
}

export function validarRfc(rfc: string, tipoPersonaId: number): boolean {
    const caracteresAdicionales = tipoPersonaId === enums.tipoPersonaRazonSocial.moral ? 3 : 4;
    const _rfc_pattern_pf = `^(([A-Z&]{${caracteresAdicionales}})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])\
|[3][01])([A-Z0-9]{3}))|(([A-Z&]{${caracteresAdicionales}})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])\
|[3][0])([A-Z0-9]{3}))|(([A-Z&]{${caracteresAdicionales}})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])\
([A-Z0-9]{3}))|(([A-Z&]{${caracteresAdicionales}})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$`;

    return !!rfc.match(_rfc_pattern_pf);
}

export function validarCurp(curp: string): boolean {
    const _rfc_pattern_pf = `^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}\
(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)\
[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$`;

    return !!curp.match(_rfc_pattern_pf);
}

export function currencyFormat(num): string {
    if (num != null) {
        return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    } else {
        return '$0';
    }
}

export function b64toBlob(b64Data, contentType = '', sliceSize = 512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays: any = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
}

export function obtenerMercancias(solicitud, saveMercancias, esCotizacion: boolean): void {
    const mercanciasSolicitud = esCotizacion ? solicitud.cotizacionMercancias : solicitud.solicitudMercancias;
    if (mercanciasSolicitud.length > 0) {
        const mercancias: Mercancia[] = [];

        mercanciasSolicitud.forEach(mercancia => {
            const nuevaMercancia = new Mercancia(initialMercancia);
            nuevaMercancia.ObtenerDeCotizacion(mercancia, esCotizacion);
            mercancias.push(nuevaMercancia);
        });

        saveMercancias(mercancias);
    }
}

export function completarValoresRecoleccion(recoleccion: IRecoleccion | Recoleccion, areaServicio: AreaServicio,
    cliente: ICliente, esOrigen: boolean, sucursal?: Sucursal,
    esCotizacion: boolean = false) {
    const esRadConCita = cliente.esRadConCita && areaServicio.esRadConCita;
    const esEadConCita = cliente.esEadConCita && areaServicio.esEadConCita;
    let serviciosAdicionales = obtenerServiciosAdicionales(areaServicio.serviciosAdicionales, esCotizacion, esOrigen);
    let serviciosOrigenDestino = serviciosAdicionales.filter(s => s.esSeccionOrigenDestino);
    const serviciosSeccionSevcios = serviciosAdicionales.filter(s => s.esSeccionServiciosAdicionales);
    const copiaAreaServicio = new AreaServicio({ ...areaServicio, serviciosAdicionales: serviciosSeccionSevcios });
    copiaAreaServicio.ObtenerGrupoHorarios();

    if (esOrigen && !esRadConCita) {
        serviciosOrigenDestino = serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA RAD')
    }
    if (!esOrigen && !esEadConCita) {
        serviciosOrigenDestino = serviciosOrigenDestino.filter(c => c.nombre !== 'CARGO POR CITA EAD')
    }

    recoleccion.areaServicio = copiaAreaServicio;
    recoleccion.sucursal = sucursal || new Sucursal(areaServicio.sucursal);
    recoleccion.aceptaCita = !recoleccion.esServicioInternacional && (esOrigen && esRadConCita) || (!esOrigen && esEadConCita);
    recoleccion.serviciosAdicionales = serviciosOrigenDestino;
}

export function obtenerServiciosAdicionales(servicios: IServicioAdicional[], esCotizacion: boolean, esOrigen: boolean):
    ServicioAdicional[] {
    let nuevosServicios: ServicioAdicional[] = [];

    servicios.forEach(s => {
        const nuevoServicio = new ServicioAdicional(s);
        nuevoServicio.ConfigurarOrigenDestino(esOrigen, esCotizacion);

        const aplicaOrigen = esOrigen
            && (esCotizacion && s.configuracion?.esOrigenCotizacion
                || !esCotizacion && s.configuracion?.esOrigenSolicitudServicio
            )

        const aplicaDestino = !esOrigen
            && (esCotizacion && s.configuracion?.esDestinoCotizacion
                || !esCotizacion && s.configuracion?.esDestinoSolicitudServicio
            )

        if (aplicaOrigen || aplicaDestino || nuevoServicio.esSeccionServiciosAdicionales) {
            nuevosServicios.push(nuevoServicio);
        }
    });

    return nuevosServicios;
}

export function getDireccionDistribuidor(distribuidor): string {
    const calle = distribuidor.calle || '';
    const noExterior = distribuidor.noExterior ? " " + distribuidor.noExterior : "";
    const noInterior = distribuidor.noInterior ? " Int. " + distribuidor.noInterior : "";
    const colonia = distribuidor.colonium?.nombreColonia ? ", " + distribuidor.colonium.nombreColonia : "";
    const codigoPostal = distribuidor.codigoPostal ? " CP. " + distribuidor.codigoPostal : "";
    const ciudad = distribuidor.colonium?.ciudad ? ", " + distribuidor.colonium.ciudad.nombre : "";
    const estado = distribuidor.colonium?.estado ? ", " + distribuidor.colonium.estado.nombre : "";
    const pais = distribuidor.colonium?.pais ? ", " + distribuidor.colonium.pais.nombre : "";
    return calle + noExterior + noInterior + colonia + codigoPostal + ciudad + estado + pais;
}
